import { Footer } from './Footer'
import React, { Component } from 'react'
import { Row, Col, Card, Container } from 'react-bootstrap'
import CajasFrias from './CadenaDeFrio/CajasFrias.jpg'
import Termos1 from './CadenaDeFrio/Termos1.jpg'
import { Navigation } from './Navigation'

export class CadenaFrio extends Component {
    render() {
        const productos = [
            { img: CajasFrias, title: "Cajas frías" },
            { img: Termos1, title: "Termos" }
        ];

        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>Cadena de Frío</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Mantenemos 2 columnas para que la línea estética sea continua 
                        con las secciones anteriores de Rehabilitación y Operaciones.
                    */}
                    <Row xs={1} md={2} lg={2} className="g-5 text-center justify-content-center">
                        {productos.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow border-0">
                                    <Card.Body className="p-2">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                height: '550px', 
                                                objectFit: 'contain',
                                                padding: '20px'
                                            }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.6rem', padding: '10px' }}>
                                            {item.title}
                                        </Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}